var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282830",
    fillRule: "evenodd",
    d: "M3.117 6.467a.4.4 0 0 1 .566 0l6.246 6.247a.1.1 0 0 0 .142 0l6.246-6.247a.4.4 0 1 1 .566.566l-6.247 6.246a.9.9 0 0 1-1.272 0L3.117 7.033a.4.4 0 0 1 0-.566",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDown;